import React from 'react';
import Button from '../DefaultButton';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

const InscriptionButton = ({ history }) => {
	const { t } = useTranslation();
	return (
		<Button
			content={t('general.actions.inscription')}
			variant={'contained'}
			color={'primary'}
			onClick={() => {
				history.push('/inscriptions');
			}}
		/>
	);
};

export default withRouter(InscriptionButton);
